import { mergeUtmParams, pickUtmParams } from "./params";

const STORAGE_KEY = "ch_utm";
const listeners = new Set<() => void>();
let current: string | undefined;

function readStored(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

function load(): string {
  return mergeUtmParams(readStored(), pickUtmParams(window.location.search));
}

/** The tracked query (UTMs and referrer) of this browsing session (tab); empty on the server or when the visit has none. */
export function getUtm(): string {
  if (typeof window === "undefined") return "";
  return (current ??= load());
}

/** Make the tracked params in `search`, if any, the session's — the latest campaign and the latest referrer win. */
export function captureUtm(search: string): void {
  const incoming = pickUtmParams(search);
  if (!incoming) return;
  const utm = mergeUtmParams(getUtm(), incoming);
  try {
    sessionStorage.setItem(STORAGE_KEY, utm);
  } catch {
    // Storage blocked: the in-memory value still covers client-side navigation.
  }
  if (utm === getUtm()) return;
  current = utm;
  listeners.forEach((listener) => listener());
}

export function subscribeUtm(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
